module.exports = __webpack_public_path__ + "img/css-logo.fc21984e.jpg";